<template>
  <generic-message-page :logo="parsePublicAssetsPath(Logo)">
    {{ $t('pages.not_found.title') }}
  </generic-message-page>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import Logo from '@/assets/not-found.svg';
import parsePublicAssetsPath from '@/utils/parsePublicAssetsPath';
import GenericMessagePage from './GenericMessagePage.vue';

onBeforeMount(() => {
  window.prerender?.pageNotFound();
});
</script>
